import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { apiColletions } from "src/app/core/constants/api_collection";

@Injectable({
  providedIn: "root"
})
export class FormFieldService {
  constructor(private apiService: ApiService) {}

  getFormFieldList(parameters = {}): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: apiColletions.formField, parameters: parameters }).subscribe({
          next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}